import { Badge, BadgeProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export default function BetaBadge(props: BadgeProps) {
  const { t } = useTranslation(['Common']);

  return (
    <Badge color="blackroomOrange" size="sm" {...props}>
      {t('Common:brand.beta')}
    </Badge>
  );
}
